import { useState } from "react";

export function useNavMenuHooks() {
    const [isOpen, setIsOpen] = useState(false);
  const [isShowDropdown, setIsShowDropdown] = useState(false);
  const [timeOutId, setTimeOutId] = useState<NodeJS.Timeout | null>(null)

   const onMouseEnterHandler = ()=>{
    if(timeOutId){
      clearTimeout(timeOutId)
    }

   const timeOut =  setTimeout(() => {
    setIsShowDropdown(true);
      setIsOpen(true);
    }, 100);

    setTimeOutId(timeOut);
  }
  return {onMouseEnterHandler, isOpen, isShowDropdown}
}

